import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BankStatementRuleJointTypeEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.joint.type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link BankStatementRuleJointTypeEnum} enumeration values */
export const BankStatementRuleJointTypeEnumI18n: EnumI18nInterface<BankStatementRuleJointTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BankStatementRuleJointTypeEnum.OR]: 'и',
    [BankStatementRuleJointTypeEnum.AND]: 'или',
  },
  [I18nLocalesEnum.EN_US]: {
    [BankStatementRuleJointTypeEnum.OR]: 'and',
    [BankStatementRuleJointTypeEnum.AND]: 'or',
  },
};
